<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="邮箱：" prop="email">
                <span>{{model.email}}</span>
            </el-form-item>
            <el-form-item label="CarId：" prop="car_id">
                <span>{{model.car_id}}</span>
            </el-form-item>
            <el-form-item label="VehicleId：" prop="vehicle_id">
                <span>{{model.vehicle_id}}</span>
            </el-form-item>
            <el-form-item label="充电数量：" prop="charge_count">
                <span>{{model.charge_count}}次</span>
            </el-form-item>
            <el-form-item label="电池健康度：" prop="battery_health">
                <span>{{model.battery_health}}%</span>
            </el-form-item>
            <el-form-item label="数据：" prop="data_str">
                <span>{{model.data_str}}</span>
            </el-form-item>
            <el-form-item label="时间：" prop="add_time">
                <span>{{model.add_time}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'batteryHealthAssessInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                member_id: '',
                email: '',
                car_info_id: '',
                car_id: '',
                vehicle_id: '',
                charge_count: '',
                battery_health: '',
                data_str: '',
                add_time: '',
            },
            getObj:{
                url:'/api/admin/batteryhealthassess/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
        };
    },
    methods: {}
};
</script>